import api from "./api";

export const dashboardApi = {
  getOverview: () => api.get("/dashboard/overview"),
};